import { Container, Spacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Root = styled(Container).attrs({
  forwardedAs: Spacer,
})`
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.05);
`;
